import React from 'react';

import { TextInput } from 'components/input';
import { SaveButton } from 'components/button';
import { SimpleForm, Toolbar } from 'components/form';
import CreateBase from 'routes/user/components/CreateBase';

import { smsCreateBackendPath } from './urls';
import { maxLength } from 'components/form/validate';
import { InputOptions } from 'util/constants'

const mobileToolbar = (
  <Toolbar>
    <SaveButton label="SEND" icon={null}/>
  </Toolbar>
);

export const SMSCreate = (props) => (
  <CreateBase reload={true} actions={false} createBackendPath={smsCreateBackendPath} {...props}>
    <SimpleForm toolbar={mobileToolbar}>
      <TextInput 
        source="mobile_number" 
        label="Phone number" 
        isRequired={true}
        validators={[maxLength(12)]} 
        options={InputOptions}
      />
      <TextInput 
        source="content" 
        label="Content" 
        isRequired={true}
        validators={[maxLength(255)]}
        options={InputOptions}
      />
    </SimpleForm>
  </CreateBase>
);


// WEBPACK FOOTER //
// ./src/routes/notification/SMSCreate.js